import { render, staticRenderFns } from "./timeDown.vue?vue&type=template&id=2808186a&scoped=true"
import script from "./timeDown.vue?vue&type=script&lang=js"
export * from "./timeDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808186a",
  null
  
)

export default component.exports